// components/ScriptManager.tsx
"use client";

import { useCookieConsentContext } from "../../hooks/cookieConsentProvider";
import Script from "next/script";

type ScriptManagerProps = {
  nonce: string;
};

export default function ScriptManager(props: ScriptManagerProps) {
  const { consent } = useCookieConsentContext();

  return (
    <>
      <Script
        nonce={props.nonce}
        src="https://www.googletagmanager.com/gtag/js?id=G-V6EP3JLPPZ"
      />
      <Script nonce={props.nonce} src="/gtag-init.js" />
      {
        consent.desempenho && (
          <Script
            nonce={props.nonce}
            src="/hotjar.js"
          />
        )
      }
    </>
  );
}
